var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Center, Icon, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, } from 'shared/components/ui';
import { CompassLogo } from 'shared/assets/icons';
import { useMe } from 'shared/hooks';
export var WelcomeModal = function (_a) {
    var _b;
    var welcomeDisclosure = _a.welcomeDisclosure;
    var userInfo = useMe();
    var modalContentProps = {
        align: 'center',
        padding: 5,
    };
    var modalHeaderProps = {
        fontSize: '27px',
        fontWeight: '600',
        padding: 0,
        mt: 3,
    };
    return (_jsxs(Modal, __assign({ isOpen: welcomeDisclosure.isOpen, onClose: welcomeDisclosure.onClose, size: "xl", isCentered: true }, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, __assign({}, modalContentProps, { children: [_jsx(Center, { children: _jsx(Icon, { boxSize: 4, as: CompassLogo, ml: "100px" }) }), _jsx(Box, __assign({ mt: 3, fontWeight: 600 }, { children: "Navigate your practice with ease" })), _jsx(Box, { children: _jsxs(ModalHeader, __assign({}, modalHeaderProps, { "data-testid": "welcomeModal" }, { children: ["Welcome to Compass, ", (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.data) === null || _b === void 0 ? void 0 : _b.first_name, "!"] })) }), _jsx(Box, __assign({ mt: 3 }, { children: "Compass is an all-in-one portal that offers intuitive experiences with frictionless integration." })), _jsx(ModalCloseButton, { "data-testid": "closeModel", color: "green.500" })] }))] })));
};
